import React from 'react';
import { Box } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PatientDetailsView from '../components/PatientDetails/PatientDetailsView';
import PatientClinicalStrip from '../components/PatientDetails/PatientClinicalStrip';

const PatientDetailsPage: React.FC = () => {
  const { spruceEntityId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as any;
  const searchParams = new URLSearchParams(location.search);

  const patientName = state?.patientName || searchParams.get('name') || undefined;
  const patientPhone = state?.patientPhone || searchParams.get('phone') || undefined;
  const patientEmail = state?.patientEmail || searchParams.get('email') || undefined;
  const patientDob = state?.patientDob || searchParams.get('dob') || undefined;
  const patientGender = state?.patientGender || searchParams.get('gender') || undefined;
  // When a task dock routed here, returnTo carries "/?taskId=<id>" so the back
  // button reopens the dashboard with that task's dock restored.
  const returnTo = state?.returnTo as string | undefined;
  const backLabel = (state?.backLabel as string | undefined) || 'Back';

  return (
    <Box>
      <PatientClinicalStrip
        spruceEntityId={spruceEntityId}
        resetSignal={spruceEntityId}
        patientName={patientName}
        patientPhone={patientPhone}
        patientEmail={patientEmail}
      />
      <PatientDetailsView
        spruceEntityId={spruceEntityId}
        patientName={patientName}
        patientPhone={patientPhone}
        patientEmail={patientEmail}
        patientDob={patientDob}
        patientGender={patientGender}
        showBackButton
        onBack={() => (returnTo ? navigate(returnTo) : navigate(-1))}
        backLabel={backLabel}
      />
    </Box>
  );
};

export default PatientDetailsPage;
